import $ from 'jquery';
import { Autoplay, EffectFade, Navigation, Pagination, Swiper } from 'swiper';

import { $Elements, Events, Durations, Breakpoints } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Related posts ----------

	$('.posts-section .section-carousel, .related-posts-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: false,
				observer: true,
				slidesPerView: 1.1,
				breakpoints: {
					[Breakpoints.sm]: {
						slidesPerView: 2.1,
					},
					[Breakpoints.lg]: {
						slidesPerView: 3.1,
					},
					[Breakpoints.xxl]: {
						slidesPerView: 4.1,
					},
				},
				modules: [Navigation],
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Team ----------

	$('.team-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: false,
				observer: true,
				slidesPerView: 1.1,
				breakpoints: {
					[Breakpoints.sm]: {
						slidesPerView: 2.1,
					},
					[Breakpoints.md]: {
						slidesPerView: 3.1,
					},
					[Breakpoints.lg]: {
						slidesPerView: 4.1,
					},
					[Breakpoints.xxl]: {
						slidesPerView: 5.1,
					},
				},
				modules: [Navigation],
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Images slider ----------

	$('.images-slider-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: false,
				observer: true,
				modules: [Navigation],
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Carousel ----------

	$('.content-section .section-carousel, .content-section .column-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: true,
				observer: true,
				modules: [Navigation, Pagination],
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Slideshow ----------

	$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});
});
